const KLEUREN = [
  'Charcoal Black','Nardo Gray','Bone White','Sunflower Yellow','Mandarin Orange',
  'Sakura Pink','Lilac Purple','Indigo Purple','Apple Green','Dark Green',
  'Ice Blue','Dark Blue','Hot Pink','Scarlet Red','Maroon Red',
  'Plum','Latte Brown','Terracotta','Dark Brown'
];
const KLEUREN_CROWN = ['Silk Gold'];

const PRODUCTEN = [
  { naam:'Base',        cat:'Base',             p25:1.85, p50:1.70, p100:1.55 },
  { naam:'Sol',         cat:'Standaard vormen', p25:1.40, p50:1.30, p100:1.20 },
  { naam:'Gem',         cat:'Standaard vormen', p25:1.40, p50:1.30, p100:1.20 },
  { naam:'Lume',        cat:'Standaard vormen', p25:1.40, p50:1.30, p100:1.20 },
  { naam:'Puck',        cat:'Standaard vormen', p25:1.40, p50:1.30, p100:1.20 },
  { naam:'UFO',         cat:'Premium vormen',   p25:1.40, p50:1.30, p100:1.20 },
  { naam:'Pebble',      cat:'Premium vormen',   p25:1.40, p50:1.30, p100:1.20 },
  { naam:'Cobble',      cat:'Premium vormen',   p25:1.40, p50:1.30, p100:1.20 },
  { naam:'Crown',       cat:'Premium accent',   p25:1.40, p50:1.30, p100:1.20, exclusiveKleuren: KLEUREN_CROWN },
  { naam:'Alu Cup Cap', cat:'Accessoire',       p25:1.40, p50:1.30, p100:1.20 },
];

function getStaffelPrijs(product, totaalStuks) {
  if (totaalStuks >= 100) return product.p100;
  if (totaalStuks >= 50)  return product.p50;
  return product.p25;
}

function getTotaalStuks() {
  let total = 0;
  document.querySelectorAll('.color-entry input[type="number"]').forEach(inp => {
    total += parseInt(inp.value) || 0;
  });
  return total;
}

function formatEur(val) {
  return '€' + val.toFixed(2).replace('.', ',');
}

function herbereken() {
  const totaalStuks = getTotaalStuks();
  const staffelIdx = totaalStuks >= 100 ? 2 : totaalStuks >= 50 ? 1 : 0;

  let grandTotal = 0;

  PRODUCTEN.forEach(product => {
    const prijs = getStaffelPrijs(product, totaalStuks);
    const row = document.getElementById(`row-${product.naam}`);
    if (!row) return;

    let productTotaal = 0;
    row.querySelectorAll('.color-entry input[type="number"]').forEach(inp => {
      productTotaal += parseInt(inp.value) || 0;
    });

    const subtotaal = productTotaal * prijs;
    grandTotal += subtotaal;

    const qtyCell = row.querySelector('.qty-cell');
    if (qtyCell) qtyCell.textContent = productTotaal > 0 ? productTotaal : '—';

    const subCell = row.querySelector('.subtotal-cell');
    if (subCell) subCell.textContent = productTotaal > 0 ? formatEur(subtotaal) : '—';

    row.querySelectorAll('.price-cell').forEach(pc => pc.classList.remove('active'));
    const priceCells = row.querySelectorAll('.price-cell');
    if (priceCells[staffelIdx]) priceCells[staffelIdx].classList.add('active');
  });

  document.getElementById('grand-total').textContent = formatEur(grandTotal + getPakkettenTotaal());
  const totaalStuksIncPakketten = totaalStuks + PAKKETTEN.reduce((sum, pk) => sum + (parseInt(document.getElementById(`pakket-aantal-${pk.id}`)?.value) || 0) * pk.stuks, 0);
  document.getElementById('total-stuks').textContent = totaalStuksIncPakketten + ' stuks';

  ['25','50','100'].forEach(s => {
    document.getElementById(`staffel-${s}`).classList.remove('active');
  });
  if (totaalStuks >= 100) document.getElementById('staffel-100').classList.add('active');
  else if (totaalStuks >= 50) document.getElementById('staffel-50').classList.add('active');
  else if (totaalStuks >= 25) document.getElementById('staffel-25').classList.add('active');
}

function addColorEntry(container, cat, kleuren) {
  const entry = document.createElement('div');
  entry.className = 'color-entry';
  entry.setAttribute('data-cat', cat);

  let sel;
  if (kleuren.length === 1) {
    sel = document.createElement('select');
    sel.style.cssText = 'flex:1;background:var(--bg);border:1px solid var(--faint);border-radius:3px;color:var(--gold);font-family:\'Poppins\',sans-serif;font-size:12px;padding:5px 28px 5px 8px;outline:none;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\'%3E%3Cpath d=\'M0 0l5 6 5-6z\' fill=\'%238A7560\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 8px center;cursor:default;';
    const opt = document.createElement('option');
    opt.value = kleuren[0];
    opt.textContent = kleuren[0];
    sel.appendChild(opt);
    sel.value = kleuren[0];
  } else {
    sel = document.createElement('select');
    kleuren.forEach(k => {
      const opt = document.createElement('option');
      opt.value = k; opt.textContent = k;
      sel.appendChild(opt);
    });
    sel.addEventListener('change', herbereken);
  }

  const numInput = document.createElement('input');
  numInput.type = 'number';
  numInput.min = '0';
  numInput.placeholder = '0';
  numInput.addEventListener('input', () => {
    herbereken();
    if (kleuren.length > 1) {
      const entries = container.querySelectorAll('.color-entry');
      const lastEntry = entries[entries.length - 1];
      if (entry === lastEntry && (parseInt(numInput.value) || 0) > 0) {
        addColorEntry(container, cat, kleuren);
      }
    }
  });

  const removeBtn = document.createElement('button');
  removeBtn.className = 'remove-btn';
  removeBtn.innerHTML = '×';
  removeBtn.type = 'button';
  removeBtn.onclick = () => {
    if (container.querySelectorAll('.color-entry').length > 1) {
      entry.remove();
      herbereken();
    }
  };

  entry.appendChild(sel);
  entry.appendChild(numInput);
  entry.appendChild(removeBtn);
  container.appendChild(entry);
}

function buildTable() {
  const wrap = document.getElementById('product-rows');
  let prevCat = null;

  PRODUCTEN.forEach((product, idx) => {
    if (product.cat !== prevCat) {
      const catBar = document.createElement('div');
      catBar.className = 'category-bar';
      catBar.innerHTML = `<span>${product.cat}</span>`;
      wrap.appendChild(catBar);
      prevCat = product.cat;
    }

    const row = document.createElement('div');
    row.className = 'product-row';
    row.id = `row-${product.naam}`;

    const main = document.createElement('div');
    main.className = 'product-row-main';

    const nameDiv = document.createElement('div');
    nameDiv.className = 'product-name';
    nameDiv.textContent = product.naam;
    if (product.exclusiveKleuren) {
      const badge = document.createElement('span');
      badge.textContent = ' ★';
      badge.title = 'Exclusief: Silk Gold';
      badge.style.cssText = 'font-size:11px;color:var(--gold);margin-left:4px;';
      nameDiv.appendChild(badge);
    }

    const colorCol = document.createElement('div');
    colorCol.style.padding = '6px 0';
    const colorEntries = document.createElement('div');
    colorEntries.className = 'color-entries';
    const kleuren = product.exclusiveKleuren || KLEUREN;
    addColorEntry(colorEntries, product.cat, kleuren);
    colorCol.appendChild(colorEntries);

    const qtyDiv = document.createElement('div');
    qtyDiv.className = 'qty-cell';
    qtyDiv.textContent = '—';
    qtyDiv.style.textAlign = 'center';

    const p25div = document.createElement('div');
    p25div.className = 'price-cell';
    p25div.textContent = formatEur(product.p25);
    p25div.style.textAlign = 'right';

    const p50div = document.createElement('div');
    p50div.className = 'price-cell';
    p50div.textContent = formatEur(product.p50);
    p50div.style.textAlign = 'right';

    const p100div = document.createElement('div');
    p100div.className = 'price-cell';
    p100div.textContent = formatEur(product.p100);
    p100div.style.textAlign = 'right';

    const subDiv = document.createElement('div');
    subDiv.className = 'subtotal-cell';
    subDiv.textContent = '—';

    main.appendChild(nameDiv);
    main.appendChild(colorCol);
    main.appendChild(qtyDiv);
    main.appendChild(p25div);
    main.appendChild(p50div);
    main.appendChild(p100div);
    main.appendChild(subDiv);

    row.appendChild(main);
    wrap.appendChild(row);
  });
}

// ─── PAKKETTEN: nieuwe structuur met standaard/premium verdeling ───
const VORMEN_STANDAARD = ['Sol','Gem','Lume','Puck'];
const VORMEN_PREMIUM   = ['UFO','Pebble','Cobble'];
const ALLE_VORMEN_PAKKET = [...VORMEN_STANDAARD, ...VORMEN_PREMIUM]; // Crown niet, die zit als add-on op losse staffel

const PAKKETTEN = [
  { id:'sample',   naam:'Sample Pakket',     prijs:44,  stuks:30,
    bases:5,  vormen_std:10, vormen_prem:10, alus:5,
    inhoud: [
      { n: '5',  label: 'Bases' },
      { n: '10', label: 'Standaard vormen' },
      { n: '10', label: 'Premium vormen' },
      { n: '5',  label: 'Alu Cup Caps + cups' }
    ] },
  { id:'display',  naam:'Color Collection',  prijs:156, stuks:114,
    bases:19, vormen_std:38, vormen_prem:38, alus:19,
    inhoud: [
      { n: '19', label: 'Bases' },
      { n: '38', label: 'Standaard vormen' },
      { n: '38', label: 'Premium vormen' },
      { n: '19', label: 'Alu Cup Caps + cups' }
    ] },
  { id:'full',     naam:'Full Color Range',  prijs:287, stuks:228, popular:true,
    bases:38, vormen_std:76, vormen_prem:76, alus:38,
    inhoud: [
      { n: '38',  label: 'Bases' },
      { n: '76',  label: 'Standaard vormen' },
      { n: '76',  label: 'Premium vormen' },
      { n: '38',  label: 'Alu Cup Caps + cups' }
    ] },
  { id:'mega',     naam:'Mega Collection',   prijs:573, stuks:456,
    bases:76, vormen_std:152, vormen_prem:152, alus:76,
    inhoud: [
      { n: '76',  label: 'Bases' },
      { n: '152', label: 'Standaard vormen' },
      { n: '152', label: 'Premium vormen' },
      { n: '76',  label: 'Alu Cup Caps + cups' }
    ] },
];

function stopProp(el) {
  ['click','mousedown','touchstart'].forEach(evt => {
    el.addEventListener(evt, e => e.stopPropagation());
  });
}

function maakKleurSelect(disabled, kleurLijst) {
  const lijst = kleurLijst || KLEUREN;
  const sel = document.createElement('select');
  sel.disabled = disabled;
  sel.style.cssText = 'flex:1;background:var(--bg);border:1px solid var(--border);border-radius:3px;color:var(--cream);font-family:Poppins,sans-serif;font-size:12px;padding:5px 28px 5px 8px;outline:none;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\'%3E%3Cpath d=\'M0 0l5 6 5-6z\' fill=\'%238A7560\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 8px center;cursor:pointer;opacity:' + (disabled ? '0.3' : '1') + ';transition:opacity 0.15s,border-color 0.15s;';
  const placeholder = document.createElement('option');
  placeholder.value = ''; placeholder.textContent = '- kleur -';
  sel.appendChild(placeholder);
  lijst.forEach(k => {
    const opt = document.createElement('option');
    opt.value = k; opt.textContent = k;
    sel.appendChild(opt);
  });
  stopProp(sel);
  return sel;
}

function maakAantalInput(disabled) {
  const inp = document.createElement('input');
  inp.type = 'number'; inp.min = '0'; inp.placeholder = '0';
  inp.disabled = disabled;
  inp.style.cssText = 'width:52px;flex-shrink:0;background:var(--bg);border:1px solid var(--border);border-radius:3px;color:var(--cream);font-family:Poppins,sans-serif;font-size:12px;padding:5px 8px;outline:none;-moz-appearance:textfield;opacity:' + (disabled ? '0.3' : '1') + ';transition:opacity 0.15s,border-color 0.15s;';
  stopProp(inp);
  return inp;
}

function addPakketVormRij(container, pkId, type) {
  // type = 'std' of 'prem'
  const rij = document.createElement('div');
  rij.className = `pakket-${type}-rij`;
  rij.style.cssText = 'display:flex;gap:6px;align-items:center;margin-bottom:5px;';

  const vormenLijst = type === 'std' ? VORMEN_STANDAARD : VORMEN_PREMIUM;

  const vormSel = document.createElement('select');
  vormSel.style.cssText = 'flex:1;background:var(--bg);border:1px solid var(--border);border-radius:3px;color:var(--cream);font-family:Poppins,sans-serif;font-size:12px;padding:5px 28px 5px 8px;outline:none;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\'%3E%3Cpath d=\'M0 0l5 6 5-6z\' fill=\'%238A7560\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 8px center;cursor:pointer;transition:border-color 0.15s;';
  const vPlaceholder = document.createElement('option');
  vPlaceholder.value = ''; vPlaceholder.textContent = `- ${type === 'std' ? 'std' : 'prem'} vorm -`;
  vormSel.appendChild(vPlaceholder);
  vormenLijst.forEach(v => {
    const opt = document.createElement('option');
    opt.value = v; opt.textContent = v;
    vormSel.appendChild(opt);
  });
  stopProp(vormSel);

  const kleurSel = maakKleurSelect(true);
  const aantalInp = maakAantalInput(true);

  const delBtn = document.createElement('button');
  delBtn.type = 'button'; delBtn.innerHTML = '×';
  delBtn.style.cssText = 'width:20px;height:20px;background:none;border:1px solid var(--faint);border-radius:3px;color:var(--muted);cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color 0.15s,color 0.15s;';
  delBtn.onmouseover = () => { delBtn.style.borderColor='#c0392b'; delBtn.style.color='#c0392b'; };
  delBtn.onmouseout  = () => { delBtn.style.borderColor='var(--faint)'; delBtn.style.color='var(--muted)'; };
  stopProp(delBtn);
  delBtn.onclick = () => {
    const rijen = container.querySelectorAll(`.pakket-${type}-rij`);
    if (rijen.length > 1) { rij.remove(); updatePakketVormTeller(pkId, type); herbereken(); }
  };

  vormSel.addEventListener('change', () => {
    const heeftVorm = vormSel.value !== '';
    kleurSel.disabled = !heeftVorm;
    kleurSel.style.opacity = heeftVorm ? '1' : '0.3';
    if (!heeftVorm) { kleurSel.value = ''; aantalInp.disabled = true; aantalInp.style.opacity = '0.3'; aantalInp.value = ''; }
    updatePakketVormTeller(pkId, type); herbereken();
  });

  kleurSel.addEventListener('change', () => {
    const heeftKleur = kleurSel.value !== '';
    aantalInp.disabled = !heeftKleur;
    aantalInp.style.opacity = heeftKleur ? '1' : '0.3';
    if (!heeftKleur) { aantalInp.value = ''; }
    updatePakketVormTeller(pkId, type); herbereken();
  });

  aantalInp.addEventListener('input', () => {
    updatePakketVormTeller(pkId, type);
    herbereken();
    const rijen = container.querySelectorAll(`.pakket-${type}-rij`);
    const isLaatste = rij === rijen[rijen.length - 1];
    if (isLaatste && vormSel.value && kleurSel.value && (parseInt(aantalInp.value)||0) > 0) {
      addPakketVormRij(container, pkId, type);
    }
  });

  rij.appendChild(vormSel);
  rij.appendChild(kleurSel);
  rij.appendChild(aantalInp);
  rij.appendChild(delBtn);
  container.appendChild(rij);
}

function updatePakketVormTeller(pkId, type) {
  const pk = PAKKETTEN.find(p => p.id === pkId);
  if (!pk) return;
  const aantalPakketten = parseInt(document.getElementById(`pakket-aantal-${pkId}`)?.value) || 0;
  const maxVormen = (type === 'std' ? pk.vormen_std : pk.vormen_prem) * aantalPakketten;
  let ingevuld = 0;
  const wrap = document.getElementById(`pakket-${type}-wrap-${pkId}`);
  if (!wrap) return;
  wrap.querySelectorAll(`.pakket-${type}-rij input[type="number"]`).forEach(inp => {
    ingevuld += parseInt(inp.value) || 0;
  });
  const teller = document.getElementById(`pakket-${type}-teller-${pkId}`);
  if (teller) {
    const over = maxVormen - ingevuld;
    const label = type === 'std' ? 'standaard vormen' : 'premium vormen';
    teller.textContent = over > 0 ? `Nog ${over} van de ${maxVormen} ${label} te verdelen` : over === 0 ? `✓ Alle ${maxVormen} ${label} verdeeld` : `⚠ ${Math.abs(over)} te veel — max ${maxVormen} ${label}`;
    teller.style.color = over === 0 ? 'var(--success)' : over < 0 ? '#e74c3c' : 'var(--muted)';
  }
}

function addPakketVasteRij(container, pkId, type) {
  const rij = document.createElement('div');
  rij.className = `pakket-${type}-rij`;
  rij.style.cssText = 'display:flex;gap:6px;align-items:center;margin-bottom:5px;';

  const kleurSel = maakKleurSelect(false);
  const aantalInp = maakAantalInput(false);

  kleurSel.addEventListener('change', () => {
    updatePakketVasteTeller(pkId, type);
    herbereken();
  });

  aantalInp.addEventListener('input', () => {
    updatePakketVasteTeller(pkId, type);
    herbereken();
    const rijen = container.querySelectorAll(`.pakket-${type}-rij`);
    const isLaatste = rij === rijen[rijen.length - 1];
    if (isLaatste && kleurSel.value && (parseInt(aantalInp.value)||0) > 0) {
      addPakketVasteRij(container, pkId, type);
    }
  });

  const delBtn = document.createElement('button');
  delBtn.type = 'button'; delBtn.innerHTML = '×';
  delBtn.style.cssText = 'width:20px;height:20px;background:none;border:1px solid var(--faint);border-radius:3px;color:var(--muted);cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color 0.15s,color 0.15s;';
  delBtn.onmouseover = () => { delBtn.style.borderColor='#c0392b'; delBtn.style.color='#c0392b'; };
  delBtn.onmouseout  = () => { delBtn.style.borderColor='var(--faint)'; delBtn.style.color='var(--muted)'; };
  stopProp(delBtn);
  delBtn.onclick = () => {
    const rijen = container.querySelectorAll(`.pakket-${type}-rij`);
    if (rijen.length > 1) { rij.remove(); updatePakketVasteTeller(pkId, type); herbereken(); }
  };

  rij.appendChild(kleurSel);
  rij.appendChild(aantalInp);
  rij.appendChild(delBtn);
  container.appendChild(rij);
}

function updatePakketVasteTeller(pkId, type) {
  const pk = PAKKETTEN.find(p => p.id === pkId);
  if (!pk) return;
  const aantalPakketten = parseInt(document.getElementById(`pakket-aantal-${pkId}`)?.value) || 0;
  const max = (type === 'bases' ? pk.bases : pk.alus) * aantalPakketten;
  let ingevuld = 0;
  document.querySelectorAll(`#pakket-${type}-wrap-${pkId} .pakket-${type}-rij input[type="number"]`).forEach(inp => {
    ingevuld += parseInt(inp.value) || 0;
  });
  const teller = document.getElementById(`pakket-${type}-teller-${pkId}`);
  if (teller) {
    const over = max - ingevuld;
    const label = type === 'bases' ? 'Bases' : 'Alu Cup Caps';
    teller.textContent = over > 0 ? `Nog ${over} van de ${max} ${label} te verdelen` : over === 0 ? `✓ Alle ${max} ${label} verdeeld` : `⚠ ${Math.abs(over)} te veel — max ${max} ${label}`;
    teller.style.color = over === 0 ? 'var(--success)' : over < 0 ? '#e74c3c' : 'var(--muted)';
  }
}

function buildPakketMix(pkId) {
  const pk = PAKKETTEN.find(p => p.id === pkId);
  const wrap = document.getElementById(`pakket-mix-${pkId}`);
  if (!wrap || wrap.children.length > 0) return;

  const aantalPakketten = parseInt(document.getElementById(`pakket-aantal-${pkId}`)?.value) || 1;

  // ── BASES ──
  const basesWrap = document.createElement('div');
  basesWrap.style.cssText = 'margin-bottom:14px;';
  basesWrap.innerHTML = `<div style="font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:5px;">${pk.bases * aantalPakketten} Bases — verdeel over kleuren</div>`;
  const basesRijen = document.createElement('div');
  basesRijen.id = `pakket-bases-wrap-${pkId}`;
  addPakketVasteRij(basesRijen, pkId, 'bases');
  basesWrap.appendChild(basesRijen);
  const basesTeller = document.createElement('div');
  basesTeller.id = `pakket-bases-teller-${pkId}`;
  basesTeller.style.cssText = 'font-size:11px;color:var(--muted);margin-top:4px;';
  basesTeller.textContent = `Nog ${pk.bases * aantalPakketten} van de ${pk.bases * aantalPakketten} Bases te verdelen`;
  basesWrap.appendChild(basesTeller);
  wrap.appendChild(basesWrap);

  // ── STANDAARD VORMEN ──
  const stdWrap = document.createElement('div');
  stdWrap.style.cssText = 'margin-bottom:14px;';
  stdWrap.innerHTML = `<div style="font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:5px;">${pk.vormen_std * aantalPakketten} Standaard vormen <span style="color:var(--faint);text-transform:none;letter-spacing:0;">(Sol, Gem, Lume, Puck)</span></div>`;
  const stdRijen = document.createElement('div');
  stdRijen.id = `pakket-std-wrap-${pkId}`;
  addPakketVormRij(stdRijen, pkId, 'std');
  stdWrap.appendChild(stdRijen);
  const stdTeller = document.createElement('div');
  stdTeller.id = `pakket-std-teller-${pkId}`;
  stdTeller.style.cssText = 'font-size:11px;color:var(--muted);margin-top:4px;';
  stdTeller.textContent = `Nog ${pk.vormen_std * aantalPakketten} van de ${pk.vormen_std * aantalPakketten} standaard vormen te verdelen`;
  stdWrap.appendChild(stdTeller);
  wrap.appendChild(stdWrap);

  // ── PREMIUM VORMEN ──
  const premWrap = document.createElement('div');
  premWrap.style.cssText = 'margin-bottom:14px;';
  premWrap.innerHTML = `<div style="font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:5px;">${pk.vormen_prem * aantalPakketten} Premium vormen <span style="color:var(--faint);text-transform:none;letter-spacing:0;">(UFO, Pebble, Cobble)</span></div>`;
  const premRijen = document.createElement('div');
  premRijen.id = `pakket-prem-wrap-${pkId}`;
  addPakketVormRij(premRijen, pkId, 'prem');
  premWrap.appendChild(premRijen);
  const premTeller = document.createElement('div');
  premTeller.id = `pakket-prem-teller-${pkId}`;
  premTeller.style.cssText = 'font-size:11px;color:var(--muted);margin-top:4px;';
  premTeller.textContent = `Nog ${pk.vormen_prem * aantalPakketten} van de ${pk.vormen_prem * aantalPakketten} premium vormen te verdelen`;
  premWrap.appendChild(premTeller);
  wrap.appendChild(premWrap);

  // ── ALU CUP CAPS ──
  const aluWrap = document.createElement('div');
  aluWrap.style.cssText = 'margin-bottom:4px;';
  aluWrap.innerHTML = `<div style="font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:5px;">${pk.alus * aantalPakketten} Alu Cup Caps — verdeel over kleuren</div>`;
  const aluRijen = document.createElement('div');
  aluRijen.id = `pakket-alus-wrap-${pkId}`;
  addPakketVasteRij(aluRijen, pkId, 'alus');
  aluWrap.appendChild(aluRijen);
  const aluTeller = document.createElement('div');
  aluTeller.id = `pakket-alus-teller-${pkId}`;
  aluTeller.style.cssText = 'font-size:11px;color:var(--muted);margin-top:4px;';
  aluTeller.textContent = `Nog ${pk.alus * aantalPakketten} van de ${pk.alus * aantalPakketten} Alu Cup Caps te verdelen`;
  aluWrap.appendChild(aluTeller);
  wrap.appendChild(aluWrap);
}

function buildPakketten() {
  const grid = document.getElementById('pakketten-grid');
  PAKKETTEN.forEach(pk => {
    const card = document.createElement('div');
    card.className = 'pakket-card' + (pk.popular ? ' popular' : '');
    card.id = `pakket-${pk.id}`;

    const inhoudHTML = pk.inhoud.map(item =>
      `<div class="inhoud-rij"><span class="inhoud-n">${item.n}</span><span class="inhoud-label">${item.label}</span></div>`
    ).join('');

    card.innerHTML = `
      <div class="pakket-naam">${pk.naam}</div>
      <div class="pakket-prijs">€${pk.prijs}</div>
      <div class="pakket-stuks">${pk.stuks} stuks · excl. BTW</div>
      <div class="pakket-inhoud">${inhoudHTML}</div>
      <div class="pakket-aantal" onclick="event.stopPropagation()">
        <label>Aantal pakketten</label>
        <input type="number" min="0" value="0" id="pakket-aantal-${pk.id}">
      </div>
      <div id="pakket-mix-${pk.id}" style="margin-top:12px;padding-top:12px;border-top:1px solid var(--border);display:none;" onclick="event.stopPropagation()" onmousedown="event.stopPropagation()"></div>`;

    card.addEventListener('click', () => togglePakket(pk.id));
    grid.appendChild(card);

    document.getElementById(`pakket-aantal-${pk.id}`).addEventListener('input', (e) => {
      e.stopPropagation();
      const val = parseInt(document.getElementById(`pakket-aantal-${pk.id}`).value) || 0;
      const card = document.getElementById(`pakket-${pk.id}`);
      const mixWrap = document.getElementById(`pakket-mix-${pk.id}`);
      if (val > 0) {
        card.classList.add('selected');
        mixWrap.style.display = 'block';
        // Clear bestaande mix als aantal pakketten verandert
        mixWrap.innerHTML = '';
        buildPakketMix(pk.id);
        ['bases','std','prem','alus'].forEach(t => updatePakketVasteTeller && updatePakketVasteTeller(pk.id, t));
      } else {
        card.classList.remove('selected');
        mixWrap.style.display = 'none';
        mixWrap.innerHTML = '';
      }
      herbereken();
    });
  });
}

function togglePakket(id) {
  const input = document.getElementById(`pakket-aantal-${id}`);
  const card  = document.getElementById(`pakket-${id}`);
  const mixWrap = document.getElementById(`pakket-mix-${id}`);
  const huidig = parseInt(input.value) || 0;
  if (huidig === 0) {
    input.value = 1;
    card.classList.add('selected');
    mixWrap.style.display = 'block';
    mixWrap.innerHTML = '';
    buildPakketMix(id);
  } else {
    input.value = 0;
    card.classList.remove('selected');
    mixWrap.style.display = 'none';
    mixWrap.innerHTML = '';
  }
  herbereken();
}

function getPakkettenTotaal() {
  let totaal = 0;
  PAKKETTEN.forEach(pk => {
    const aantal = parseInt(document.getElementById(`pakket-aantal-${pk.id}`)?.value) || 0;
    totaal += aantal * pk.prijs;
  });
  return totaal;
}

async function verzendFormulier() {
  const bedrijf = document.getElementById('bedrijfsnaam').value.trim();
  const email   = document.getElementById('email').value.trim();

  if (!bedrijf || !email) {
    alert('Vul minimaal bedrijfsnaam en e-mailadres in.');
    return;
  }

  // Pakketten
  let pakketRegels = [];
  PAKKETTEN.forEach(pk => {
    const aantal = parseInt(document.getElementById(`pakket-aantal-${pk.id}`)?.value) || 0;
    if (aantal > 0) {
      pakketRegels.push(`${pk.naam} x${aantal} — €${(aantal * pk.prijs).toFixed(2)}`);

      // Bases
      const basesRijen = document.querySelectorAll(`#pakket-bases-wrap-${pk.id} .pakket-bases-rij`);
      basesRijen.forEach(rij => {
        const kleur = rij.querySelector('select')?.value;
        const n = parseInt(rij.querySelector('input[type="number"]')?.value) || 0;
        if (kleur && n > 0) pakketRegels.push(`  Base ${kleur}: ${n}x`);
      });

      // Standaard vormen
      const stdRijen = document.querySelectorAll(`#pakket-std-wrap-${pk.id} .pakket-std-rij`);
      stdRijen.forEach(rij => {
        const vorm  = rij.querySelectorAll('select')[0]?.value;
        const kleur = rij.querySelectorAll('select')[1]?.value;
        const n     = parseInt(rij.querySelector('input[type="number"]')?.value) || 0;
        if (vorm && kleur && n > 0) pakketRegels.push(`  ${vorm} ${kleur}: ${n}x`);
      });

      // Premium vormen
      const premRijen = document.querySelectorAll(`#pakket-prem-wrap-${pk.id} .pakket-prem-rij`);
      premRijen.forEach(rij => {
        const vorm  = rij.querySelectorAll('select')[0]?.value;
        const kleur = rij.querySelectorAll('select')[1]?.value;
        const n     = parseInt(rij.querySelector('input[type="number"]')?.value) || 0;
        if (vorm && kleur && n > 0) pakketRegels.push(`  ${vorm} ${kleur}: ${n}x`);
      });

      // Alu Cup Caps
      const aluRijen = document.querySelectorAll(`#pakket-alus-wrap-${pk.id} .pakket-alus-rij`);
      aluRijen.forEach(rij => {
        const kleur = rij.querySelector('select')?.value;
        const n = parseInt(rij.querySelector('input[type="number"]')?.value) || 0;
        if (kleur && n > 0) pakketRegels.push(`  Alu Cup Cap ${kleur}: ${n}x`);
      });
    }
  });

  // Losse producten
  let losseRegels = [];
  PRODUCTEN.forEach(product => {
    const row = document.getElementById(`row-${product.naam}`);
    if (!row) return;
    row.querySelectorAll('.color-entry').forEach(entry => {
      const selEl = entry.querySelector('select') || entry.querySelector('div[data-kleur]');
      const kleur = selEl ? (selEl.value || selEl.textContent.trim()) : '—';
      const aantal = parseInt(entry.querySelector('input[type="number"]').value) || 0;
      if (aantal > 0) losseRegels.push(`${product.naam} - ${kleur}: ${aantal} stuks`);
    });
  });

  if (pakketRegels.length === 0 && losseRegels.length === 0) {
    alert('Vul minimaal één product of pakket in.');
    return;
  }

  const totaal = document.getElementById('grand-total').textContent;
  const opm    = document.getElementById('opmerkingen').value.trim();

  const bestellingTekst = [
    pakketRegels.length ? 'PAKKETTEN:\n' + pakketRegels.join('\n') : '',
    losseRegels.length  ? 'LOSSE PRODUCTEN:\n' + losseRegels.join('\n') : '',
  ].filter(Boolean).join('\n\n');

  const berichtTekst =
    `Bedrijf: ${bedrijf}\n` +
    `Contactpersoon: ${document.getElementById('contactpersoon').value}\n` +
    `E-mail: ${email}\n` +
    `Telefoon: ${document.getElementById('telefoon').value}\n` +
    `Adres: ${document.getElementById('adres').value}, ${document.getElementById('postcode').value} ${document.getElementById('stad').value}\n\n` +
    bestellingTekst + '\n\n' +
    `Totaal (excl. BTW): ${totaal}\n` +
    (opm ? `\nOpmerkingen:\n${opm}` : '');

  // Verzend via Formspree
  const btn = document.querySelector('.btn-primary');
  btn.textContent = 'Versturen...';
  btn.disabled = true;

  try {
    const response = await fetch('https://formspree.io/f/mbdqyded', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        bedrijf, email,
        contactpersoon: document.getElementById('contactpersoon').value,
        telefoon: document.getElementById('telefoon').value,
        adres: `${document.getElementById('adres').value}, ${document.getElementById('postcode').value} ${document.getElementById('stad').value}`,
        bestelling: berichtTekst,
        totaal,
      })
    });

    if (response.ok) {
      btn.textContent = '✓ Bestelling verstuurd!';
      btn.style.background = 'var(--success)';
      setTimeout(() => {
        btn.textContent = 'Bestelling versturen →';
        btn.style.background = '';
        btn.disabled = false;
      }, 4000);
    } else {
      throw new Error('Verzenden mislukt');
    }
  } catch (err) {
    btn.textContent = 'Bestelling versturen →';
    btn.disabled = false;
    alert('Er ging iets mis. Probeer het opnieuw of mail naar info@sunkenorangedesign.com');
  }
}

// Init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    buildPakketten();
    buildTable();
    herbereken();
  });
} else {
  buildPakketten();
  buildTable();
  herbereken();
}